<template>
  <div>
    <div v-if="Math.round(score) >= minimumScore && placement === 'product'" class="flex">
      <fa
        v-for="s in Array.from(Array(Math.floor(score)))"
        :key="s"
        class="text-star-yellow"
        :icon="['fas', 'star']"
      />

      <fa
        v-if="score - Math.floor(score) >= 0.8 && score != Math.floor(score)"
        class="text-star-yellow"
        :icon="['fas', 'star']"
      />
      <fa
        v-else-if="score - Math.floor(score) <= 0.2 && score != Math.floor(score)"
        class="text-star-yellow"
        :icon="['far', 'star']"
      />
      <fa
        v-else-if="score != Math.floor(score)"
        class="text-star-yellow"
        :icon="['fas', 'star-half-alt']"
      />

      <fa
        v-for="s in Array.from(Array(Math.floor(5 - score)))"
        :key="s"
        class="text-star-yellow"
        :icon="['far', 'star']"
      />
    </div>
    <div v-if="Math.round(score) >= minimumScore && placement === 'spot'" class="flex text-xs mt-2">
      {{ score.toFixed(1) }}<fa class="ml-6 mt-2 text-star-yellow" :icon="['fas', 'star']" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  props: {
    score: {
      type: Number,
      default: 0,
    },
    minimumScore: {
      type: Number,
      default: 0,
    },
    placement: {
      type: String,
      default: 'spot',
    },
  },
  computed: {

  },
});
</script>
